module.exports = __webpack_public_path__ + "static/media/logo.cbe72c30.png";